<template>
    <div id="stages">
      <ul class="progressbar">
        <li class="stage"
            v-for="(stage, index) in sections" v-if="stage.display"
            v-bind:class="{active: currentSection === index, activeSecondLine: currentSection > index || currentSection === sections.length - 1}"
            :key="index"
        >
            <div class="paw-svg">
                <svg viewBox="0 0 12 15.2" width="100%" height="100%">
                  <path d="M6.3 7.8c.7-.3 1.3-.7 2-.9.9-.3 2.5.3 2.6 1.7 0 .6-.2 1.3-.5 1.8-.5.8-1.1 1.5-1.6 2.3-.3.5-.6 1.1-.9 1.7-.5 1-.9 1-1.4.2-.5-.8-1.3-1.2-2.1-1.6-.9-.4-1.3-1.2-1.6-2-.3-.8-.5-1.6-.2-2.4.3-.9 1.8-1.9 2.9-1.2.3.2.7.3.8.4zM6.7 2.2c-.2.6-.5 1.3-.8 2-.2.6-.8.5-1.2.4-.3-.1-.6-.5-.8-.8-.4-.8-.4-1.7-.1-2.7C4 .6 4.7 0 5.3 0c.7 0 .8.5 1 .9.2.4.2.8.4 1.3zM7.2 3c.1-.4.1-.7.2-1C7.7.8 7.8.8 8.9.8c.7 0 1 .2 1 .9 0 .8 0 1.6-.4 2.4-.2.5-.7.7-1.2.8-.6.2-.9-.3-1-1.2 0-.2 0-.4-.1-.7.1 0 .1 0 0 0zM.1 5.2c.1-.4.1-.8.2-1.2.3-.8 1.2-.9 1.8-.4.7.7.6 1.4.4 2.2-.1.5-.3.9-.4 1.3-.3.6-1 .6-1.4 0C.4 6.5.2 5.9 0 5.3c0 0 .1 0 .1-.1zM12 5.1c0 1-.4 1.7-.9 1.8-.2 0-.4 0-.5-.2-.6-.7-.5-1.5-.2-2.2.2-.5.6-.6 1-.5.8.1.6.7.6 1.1z"></path>
              </svg>
            </div>
            <div class="name" @click="jumpToSection(index)">
              {{ stage.displayName | kebabToTitleCase }}
            </div>
        </li>
      </ul>
    </div>
</template>
<script>
export default {
  name: 'enquiry-form-section-breadcrumb',
  props: {
    currentSection: {},
    sections: {}
  },

  filters: {
    kebabToTitleCase: function (value) {
      if (!value) return ''
      return value.split('-').map(function (item) {
        return item.charAt(0).toUpperCase() + item.substring(1)
      }).join(' ')
    }
  },

  methods: {
    jumpToSection: function (index) {
      // this.$emit('jumpToSection', index)
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/frontend-vue/components/forms/enquiry-form-section-breadcrumb.vue